module.exports = __webpack_public_path__ + "static/media/lesson-menu.299d1292.png";